import { Flex } from 'antd'
import { useState } from 'react'

import { AppsBoard } from './AppsBoard'
import { CreateCustomAppDrawer } from './CreateCustomAppDrawer'

type Props = {
  workspaceId: number
  openCreateOnMount?: boolean
}

/**
 * Apps landing surface. There are no tabs any more: `is_installed` on the
 * repositories endpoint already carries the installed/available split, so
 * Installed and Catalog became one board with state as a filter, and Custom apps
 * became a create action rather than a peer list.
 */
export const AppsPageTabs = ({ workspaceId, openCreateOnMount }: Props) => {
  const [createDrawerOpen, setCreateDrawerOpen] = useState(
    Boolean(openCreateOnMount)
  )

  return (
    <Flex vertical gap={14}>
      <AppsBoard
        workspaceId={workspaceId}
        onCreateCustom={() => setCreateDrawerOpen(true)}
      />

      <CreateCustomAppDrawer
        workspaceId={workspaceId}
        open={createDrawerOpen}
        onClose={() => setCreateDrawerOpen(false)}
      />
    </Flex>
  )
}
